export const EMAIL_PROVIDERS = {
  activeCampaign: 'active_campaign',
  mailChimp: 'mail_chimp',
  getResponse: 'get_response',
  mailingWork: 'mailing_work',
}

export const INTEGRATIONS = {
  closeCrm: 'close_crm',
  trackleads: 'trackleads',
  klickTipp: 'klick_tipp',
  zapier: 'zapier',
  ...EMAIL_PROVIDERS,
  chat: 'chat',
  api: 'api',
  vimeoVideos: 'vimeo_videos',
  hubspot: 'hubspot',
  tracify: 'tracify',
}

const { chat, api, mailingWork, trackleads, ...integrations } = INTEGRATIONS
export const CUSTOM_FIELDS_INTEGRATIONS_LIST = Object.values(integrations)

export const OPTION_KEY_RESTRICTED_INTEGRATIONS = [INTEGRATIONS.vimeoVideos, INTEGRATIONS.hubspot]

export const INTEGRATIONS_TOOLTIPS = {
  klick_tipp: I18n.t('react.cabinet.help_icon.klick_tipp.content'),
  zapier: I18n.t('react.cabinet.help_icon.zapier.content'),
  active_campaign: I18n.t('react.cabinet.help_icon.active_campaign.content'),
  mail_chimp: I18n.t('react.cabinet.help_icon.mail_chimp.content'),
  get_response: I18n.t('react.cabinet.help_icon.get_response.content'),
  mailing_work: I18n.t('react.cabinet.help_icon.mailing_work.content'),
  chat: I18n.t('react.cabinet.help_icon.chat.content'),
  api: I18n.t('react.cabinet.help_icon.api.content'),
  vimeo_videos: I18n.t('react.cabinet.help_icon.vimeo_videos.content'),
  hubspot: I18n.t('react.cabinet.help_icon.hubspot.content'),
  tracify: I18n.t('react.cabinet.help_icon.tracify.content'),
  trackleads: I18n.t('react.cabinet.help_icon.trackleads.content'),
}
